module.exports = __webpack_public_path__ + "img/ico-9-active.8453281d.svg";